module.exports = __webpack_public_path__ + "img/生产工厂.0649b63f.png";